var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_32452_9901)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 6.25029L5.9913 12.8667C5.76258 13.1023 5.63576 13.4184 5.63823 13.7468C5.6407 14.0751 5.77227 14.3893 6.00451 14.6214C6.23674 14.8536 6.55099 14.985 6.87934 14.9873C7.20769 14.9897 7.52376 14.8627 7.75927 14.6339L15.5179 6.76825C15.9868 6.29936 16.2502 5.6634 16.2502 5.00029C16.2502 4.33717 15.9868 3.70121 15.5179 3.23232C15.049 2.76342 14.413 2.5 13.7499 2.5C13.0868 2.5 12.4508 2.76342 11.9819 3.23232L4.22333 11.0987C3.52953 11.8039 3.14249 12.7547 3.14652 13.744C3.15054 14.7332 3.54531 15.6808 4.24483 16.3803C4.94436 17.0799 5.89195 17.4746 6.88122 17.4787C7.87048 17.4827 8.82126 17.0956 9.52645 16.4018L15.9374 10.0003",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32452_9901"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentIcon);
export default __webpack_public_path__ + "static/media/attachmentIcon.489719cfdb0cd3ad025dde841424321b.svg";
export { ForwardRef as ReactComponent };